import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../../../lib/supabaseClient';
import { installerAdminApi } from '../../../utils/installerApi';
import { formatEn } from '../../../utils/faFormat';
import '../../../styles/InstallerAdmin.css';

async function getToken() { const { data: { session } } = await supabase.auth.getSession(); return session?.access_token; }

const STATUS_FA = {
  open: 'باز', in_progress: 'در حال اصلاح', fixed: 'رفع‌شده (در انتظار تأیید)',
  approved: 'تأیید‌شده', rejected: 'ردشده',
};

// Nassabeh Phase 2: the admin (supervisor stand-in) reviews a job's AI-found
// defects and approves / rejects the ones the installer marked fixed.
export default function JobDefectsReview({ jobId, onClose }) {
  const [defects, setDefects] = useState(null);
  const [err, setErr] = useState(null);

  const load = useCallback(async () => {
    try {
      const token = await getToken();
      const r = await installerAdminApi.jobDefects(token, jobId);
      setDefects(r.defects || []);
      setErr(null);
    } catch (e) { setErr(e.message); }
  }, [jobId]);
  useEffect(() => { load(); }, [load]);

  const act = async (defectId, status) => {
    setErr(null);
    try {
      const token = await getToken();
      await installerAdminApi.setDefectStatus(token, defectId, status);
      await load();
    } catch (e) { setErr(e.message); }
  };

  return (
    <div className="iadmin">
      <div className="iadmin-overlay" onClick={onClose}>
        <div role="dialog" className="iadmin-modal" onClick={(e) => e.stopPropagation()}>
          <div className="iadmin-modal-head">
            <h3 className="iadmin-modal-title">بازبینی ایرادها</h3>
            <button className="iadmin-x" onClick={onClose} aria-label="بستن">×</button>
          </div>
          <div className="iadmin-modal-body">
            {err && <div role="alert" className="iadmin-alert">{err}</div>}
            {defects === null && !err && <p className="iadmin-muted">در حال بارگذاری...</p>}
            {defects && defects.length === 0 && <p className="iadmin-muted">ایرادی ثبت نشده است.</p>}
            {defects && defects.length > 0 && (
              <div className="iadmin-list">
                {defects.map((d) => (
                  <div key={d.id} className="iadmin-job" style={{ alignItems: 'stretch' }}>
                    <strong>{d.rule ? formatEn(d.rule) : 'ایراد'}</strong>
                    {d.description && <span className="iadmin-muted">{d.description}</span>}
                    <span className="iadmin-muted">وضعیت: {STATUS_FA[d.status] || formatEn(d.status)}</span>
                    {d.status === 'fixed' && (
                      <div className="iadmin-job-controls">
                        <button className="iadmin-btn" onClick={() => act(d.id, 'approved')}>تأیید</button>
                        <button className="iadmin-btn iadmin-btn-ghost" onClick={() => act(d.id, 'rejected')}>رد</button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
